import React, { useRef, useEffect, useState } from "react";
import { Button } from "antd";
import { ChevronLeft, ChevronRight } from "lucide-react";

const HorizontalScrollWrapper = ({
  children,
  scrollStep = 300,
  style = {},
}) => {
  const containerRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      setAtStart(container.scrollLeft <= 5);
      setAtEnd(
        container.scrollLeft + container.clientWidth >=
          container.scrollWidth - 5
      );
    };

    handleScroll();
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollLeft = () => {
    containerRef.current?.scrollBy({ left: -scrollStep, behavior: "smooth" });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({ left: scrollStep, behavior: "smooth" });
  };

  return (
    <div style={{ position: "relative" }}>
      {!atStart && (
        <Button
          shape="circle"
          icon={<ChevronLeft size={18} style={{ marginBottom: -3 }} />}
          onClick={scrollLeft}
          style={{
            position: "absolute",
            left: 8,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            background: "#fff",
          }}
        />
      )}

      <div
        ref={containerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          paddingBottom: 8,
          gap: 16,
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          ...style,
        }}
        className="custom-scroll"
      >
        {children}
      </div>

      {!atEnd && (
        <Button
          shape="circle"
          icon={<ChevronRight size={18} style={{ marginBottom: -3 }} />}
          onClick={scrollRight}
          style={{
            position: "absolute",
            right: 8,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            background: "#fff",
          }}
        />
      )}
    </div>
  );
};

export default HorizontalScrollWrapper;
